import React from 'react'
import CandidatesHireTalent from './components/HireTalentPage'
import FooterSection from '../reusable/FooterSection'

const HireTalent: React.FC = () => {
  return (
    <div>
      <CandidatesHireTalent />
      <FooterSection />
    </div>
  )
}

export default HireTalent